import BaseObject from '../../../../base/base_object';
import Model from './geo_hybrid_model';
import {SERIVCES_FUNC_LIST, FEATURE_CB_FUNC} from '../../native/native_const';
import Event from '../../../../utils/event';
import {SYSTEM_EVENTS} from '../../../../events/events';
import {GEO} from './geo_hybrid_consts';


/**
 *
 *
 */
class Geo extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'Geo';

    _model = null;
    _HybridService = null;
    _isFeatureEnable = false;


    init(params) {

        super.init();

        this._model = Model.create(params);

        this._subscribe();
    }


    _subscribe() {
        Event.on(SYSTEM_EVENTS.GEO_HYBRID_UPDATE_ENABLE, this._updateEnable, this);
        Event.on(SYSTEM_EVENTS.GEO_HYBRID_GT_CB, this.onHybridDirectCall, this);
    }

    _updateEnable(val){

        if(null !== this._HybridService){

            this._isFeatureEnable = val;

            if(this._isFeatureEnable) {
                Event.on(SYSTEM_EVENTS.GEO_HYBRID_GET_LOCATION, this._getGeoLocation, this);
                this._HybridService.setCbFunction(SERIVCES_FUNC_LIST.GEO_SET_CB, FEATURE_CB_FUNC.HYBRID_GEO_CALL);
            }
        }
    }

    _getGeoLocation(data){

        let bValid = this._isFeatureEnable && this._model.isValidData(data);

        if(bValid) {
            data[GEO.GEO_CB_RES] = 'onGeoLocationRes';
            this._HybridService.getGeoLocation(data);
        }

        return bValid;
    }


    onHybridDirectCall(data) {
        this._executeFunc(data);
    }

    _executeFunc(data) {
        let fn = this._model.getFuncName(data);

        if('function' === typeof this[fn]) {
            this[fn](data);
        }
    }

    onGeoLocationRes(data) {
        try{
            this._sendElasticEvent('onGeoLocationRes', 'geoResponse', JSON.stringify(data));
        }catch(e){
            this._sendElasticEvent('onGeoLocationRes', 'geoResponse','X');
        }


        let allData = this._model.geoLocationRes(data);
        Event.fire(SYSTEM_EVENTS.GEO_HYBRID_GET_LOCATION_RES, allData);
    }

    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;
        return this;
    }

    _sendElasticEvent(action, label, value){
        const dataToSend  = {
            CGPEventCategory: 'hybrid_geo_feature',
            CGPEventAction: action,
            CGPEventLabel: label,
            CGPEventValue: value
        };
        this._HybridService.serviceFactory.structuredLoggingService().getLogger(dataToSend).info();
    }
}

export default Geo;
